<template>
  <div class="palette" :style="cssVars"></div>
</template>

<script>
export default {
  props: {
    bgColor: {
      type: String,
      default: "#0099cc",
    },
  },
  computed: {
    cssVars() {
      return {
        "--bg-color": this.bgColor,
        height: `30px`,
        width: `30px`,
      };
    },
  },
};
</script>

<style scoped>
.palette {
  background-color: var(--bg-color);
  border: 1px solid white;
  border-radius: 5px;
  margin-left: 5px;
  margin-top: auto;
  margin-bottom: auto;
}
</style>